<template>
  <div class="md-card md-card-stats">
    <div class="md-card-header md-card-header-icon" :class="getClass(headerColor)">
      <slot name="header"></slot>
    </div>
    <div class="md-card-content">
      <slot name="content"></slot>
    </div>
    <div class="md-card-actions" style="text-align: right;">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "stats-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>
